/** Walk analysis report tab */

import {
  HipExtensionTerminalStanceModalContent,
  HipExtensionTerminalSwingModalContent,
  KneeExtensionTerminalStanceModalContent,
  KneeFlexionMidstanceModalContent,
  KneeFlexionMidswingModalContent,
  KneeStabilityLoadingResponseModalContent,
  PelvicObliquityModalContent,
  VarusValgusModalContent,
} from '@/pages/ReportV2/components/Modals';
import { IonCol, IonRow, IonText } from '@ionic/react';

import { AttractorCard } from '@/components/Cards';

import HipExtensionAtTerminalStance from '@/assets/avatars/walk/analysis/HipExtensionAtTerminalStance.png';
import HipExtensionAtTerminalSwing from '@/assets/avatars/walk/analysis/HipExtensionAtTerminalSwing.png';
import KneeExtensionAtTerminalStance from '@/assets/avatars/walk/analysis/KneeExtensionAtTerminalStance.png';
import KneeFlexionAtMidstance from '@/assets/avatars/walk/analysis/KneeFlexionAtMidstance.png';
import KneeFlexionAtMidswing from '@/assets/avatars/walk/analysis/KneeFlexionAtMidswing.png';
import KneeStabilityAtLoadingResponse from '@/assets/avatars/walk/analysis/KneeStabilityAtLoadingResponse.png';
import PelvicObliquity from '@/assets/avatars/walk/analysis/PelvicObliquity.png';
import VarusValgus from '@/assets/avatars/walk/analysis/VarusValgus.png';

import { AnalysisData } from '@/models/reportV2.model';

type WalkReportProps = {
  tabData: AnalysisData;
};

/** The Walk analysis report tab
 * @param report - The full walk report info and data
 */
export const WalkAnalysisReportTab = ({ tabData }: WalkReportProps) => {
  if (!tabData) {
    return <IonText>Data not found.</IonText>;
  }
  return (
    <>
      <IonRow>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.kpiData[1]}
            img={HipExtensionAtTerminalStance}
            info={<HipExtensionTerminalStanceModalContent />}
            kpiLabels={tabData.kpiLabels[0]}
            subtitle='Terminal stance'
            title='Hip extension'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.kpiData[0]}
            img={KneeExtensionAtTerminalStance}
            info={<KneeExtensionTerminalStanceModalContent />}
            kpiLabels={tabData.kpiLabels[2]}
            subtitle='Terminal stance'
            title='Knee extension'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.kpiData[6]}
            img={KneeFlexionAtMidswing}
            info={<KneeFlexionMidswingModalContent />}
            kpiLabels={tabData.kpiLabels[0]}
            subtitle='Midswing'
            title='Knee flexion'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.kpiData[2]}
            img={HipExtensionAtTerminalSwing}
            info={<HipExtensionTerminalSwingModalContent />}
            kpiLabels={tabData.kpiLabels[0]}
            subtitle='Terminal swing'
            title='Hip extension'
          />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.kpiData[3]}
            img={KneeStabilityAtLoadingResponse}
            info={<KneeStabilityLoadingResponseModalContent />}
            kpiLabels={tabData.kpiLabels[0]}
            subtitle='Loading response'
            title='Knee stability'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.kpiData[5]}
            img={KneeFlexionAtMidstance}
            info={<KneeFlexionMidstanceModalContent />}
            kpiLabels={tabData.kpiLabels[0]}
            subtitle='Midstance'
            title='Knee flexion'
          />
        </IonCol>

        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.kpiData[7]}
            img={VarusValgus}
            info={<VarusValgusModalContent />}
            kpiLabels={tabData.kpiLabels[0]}
            subtitle='Midstance'
            title='Varus / Valgus'
            varusValgus={[tabData.varusValgusLabel_Left, tabData.varusValgusLabel_Right]}
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.kpiData[4]}
            img={PelvicObliquity}
            info={<PelvicObliquityModalContent />}
            kpiLabels={tabData.kpiLabels[1]}
            subtitle='Midstance'
            title='Pelvic obliquity'
          />
        </IonCol>
      </IonRow>
    </>
  );
};
